import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import Game from "@/assets/js/game-logic";
import { clamp } from "@/assets/js/math";
import { debounce } from "@/assets/js/debounce";

export enum ActivitySize {
  DESKTOP = "desktop",
  TABLET = "tablet",
  MOBILE = "mobile",
  TINY = "tiny",
}
const TINY_WIDTH = 520;
const MOBILE_WIDTH = 600;
const TABLET_WIDTH = 1250;
const DESKTOP_MIN_WIDTH = 1000;

const store = new Vuex.Store({
  state: {
    game: new Game(),
    width: 0,
    size: ActivitySize.DESKTOP,
  },
  mutations: {
    setWidth(state, width: number) {
      state.width = width;
    },
    setSize(state, size: ActivitySize) {
      state.size = size;
    },
  },
});

function getFontSize(width: number): number {
  const fontSize = (width / DESKTOP_MIN_WIDTH) * 16;
  return clamp(fontSize, 10, 16);
}

function resize() {
  const width = window.innerWidth;
  //size
  if (width <= TINY_WIDTH) {
    store.commit("setSize", ActivitySize.TINY);
  } else if (width <= MOBILE_WIDTH) {
    store.commit("setSize", ActivitySize.MOBILE);
  } else if (width <= TABLET_WIDTH) {
    store.commit("setSize", ActivitySize.TABLET);
  } else {
    store.commit("setSize", ActivitySize.DESKTOP);
  }
  const size = getFontSize(width) + "px";
  document.documentElement.style.fontSize = size;
  store.commit("setWidth", width);
}
window.addEventListener("resize", debounce(resize, 500));
resize();

export default store;
